import { organizationModule } from '@/store/organization/module'
import { integrationsModule } from './module'
import { isPromise } from '@/utils'

const getCurrentIntegrations = () => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const currentIntegrations = currentOrganization
        && integrationsModule.state.integrations[currentOrganization.objectId]?.value

    if (currentIntegrations && (!isPromise(currentIntegrations))) {
        return currentIntegrations
    } else {
        return []
    }
}

const getCurrentCourseIntegrations = () => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const currentCourseIntegrations = currentOrganization
        && integrationsModule.state.courseIntegrations[currentOrganization.objectId]?.value

    if (currentCourseIntegrations && (!isPromise(currentCourseIntegrations))) {
        return currentCourseIntegrations
    } else {
        return null
    }
}

export default {
    getCurrentIntegrations,
    getCurrentCourseIntegrations,
}
